import analytics from 'analytics';

import { mixpanelPlugin } from 'src/services/analytics/plugins/mixpanel';

export const analyticsClient = analytics({
    app: import.meta.env.VITE_APP_NAME,
    plugins: [mixpanelPlugin]
});